import { useState, ChangeEvent } from 'react'
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  SelectChangeEvent,
} from '@mui/material'

interface SelectSimpleRoleProps {
  onChange: (value: string) => void
}

const SelectSimpleRole = ({ onChange }: SelectSimpleRoleProps) => {
  const [value, setValue] = useState('')

  const handleChange = (e: SelectChangeEvent<string>) => {
    const newVal = e.target.value
    setValue(newVal)
    onChange(newVal)
  }

  return (
    <FormControl fullWidth size="small">
      <InputLabel id="role">Role</InputLabel>
      <Select
        sx={{ fontSize: '1em' }}
        labelId="role"
        value={value}
        onChange={handleChange}
        label="Role"
      >
        <MenuItem value="admin">Admin</MenuItem>
        <MenuItem value="user">User</MenuItem>
      </Select>
    </FormControl>
  )
}

export default SelectSimpleRole
